import { render, staticRenderFns } from "./PesapaliFrame.vue?vue&type=template&id=ffb83a7e"
import script from "./PesapaliFrame.vue?vue&type=script&lang=js"
export * from "./PesapaliFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports